const ChangeCamelToSnakeCase = (key: string): string => {
  return key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};
export default ChangeCamelToSnakeCase;
